/**
 * HTMX and styles for lazily rendered blocks.
 */

import 'htmx.org';
import './lazy-render.scss';

window.htmx = require('htmx.org');

window.htmx.config.historyEnabled = false;
window.htmx.config.selfRequestsOnly = true;

if (module.hot) {
  module.hot.accept();
}
